var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv ng-if=\"vm.loading\" layout=\"row\" layout-align=\"space-around center\" flex\u003E\u003Cmd-progress-circular md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!vm.loading\" layout=\"row\"\u003E\u003Cdiv style=\"position: relative;\"\u003E\u003Cdiv class=\"left-arrow\" layout=\"column\"\u003E\u003Ca ng-if=\"vm.previousLoanRequest\" href ng-click=\"vm.navigateToLoanRequest(vm.previousLoanRequest)\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-icon\u003Earrow_back\u003C\u002Fmd-icon\u003E\u003Cdiv\u003EPrevious\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv flex=\"100\" flex-md=\"60\" flex-lg=\"70\" flex-xl=\"80\"\u003E\u003Cmd-tabs class=\"md-primary\" md-no-pagination=\"false\" md-swipe-content=\"true\" md-selected=\"vm.selectedIndex\"\u003E\u003Cmd-tab ng-repeat=\"tab in vm.tabs\" md-on-select=\"vm.onSelectTab(tab)\"\u003E\u003Cmd-tab-label\u003E\u003Cspan ng-class=\"tab.class\"\u003E{{ [tab.longName, tab.shortName] | mediaSelect: 'gt-sm' }}\u003Cmd-icon ng-if=\"tab.icon\"\u003E{{ tab.icon }}\u003C\u002Fmd-icon\u003E\u003C\u002Fspan\u003E\u003C\u002Fmd-tab-label\u003E\u003C\u002Fmd-tab\u003E\u003C\u002Fmd-tabs\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-gt-md=\"80\" flex-offset-md=\"5\" flex-offset-gt-md=\"10\"\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auction-box\" layout=\"row\" if-media-size=\"gt-sm\" flex\u003E\u003Cdiv class=\"gutter\" flex\u003E\u003Cdiv layout=\"column\" ng-if=\"vm.hasLoan || vm.hasAuction\"\u003E\u003Cauction-pane class=\"md-whiteframe-2dp\" ng-if=\"!vm.hasLoan\" auction=\"vm.auction\"\u003E\u003C\u002Fauction-pane\u003E\u003Clistings-pane class=\"md-whiteframe-2dp\" ng-if=\"vm.hasLoan\" loan-request=\"vm.loanRequest\"\u003E\u003C\u002Flistings-pane\u003E\u003Cposition-pane loan-request=\"vm.loanRequest\" loan-request-navigator=\"vm.loanRequestNavigator\"\u003E\u003C\u002Fposition-pane\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"gutter\" flex=\"20\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv style=\"position: relative;\"\u003E\u003Cdiv class=\"right-arrow\" layout=\"column\"\u003E\u003Ca ng-if=\"vm.nextLoanRequest\" href ng-click=\"vm.navigateToLoanRequest(vm.nextLoanRequest)\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cdiv\u003ENext\u003C\u002Fdiv\u003E\u003Cmd-icon\u003Earrow_forward\u003C\u002Fmd-icon\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;